export default {
  'orderDetail.title': '订单详情',

  'orderDetail.lineItems.summary': '订单明细: {count} 项',
  'orderDetail.lineItem.quantity': '数量',
  'orderDetail.lineItem.description': '描述',
  'orderDetail.lineItem.price': '价格',
  'orderDetail.lineItem.notes': '菜品备注：',
  'orderDetail.lineItem.discount': '菜品折扣',
  'orderDetail.lineItem.name': '菜品名',
  'orderDetail.lineItem.customizations': '附加选项',
  'orderDetail.lineItem.thirdLevelItems': '三级菜单',
  'orderDetail.platform': '平台:',
  'orderDetail.externalOrderNumber': '外部订单号:',
  'orderDetail.cartNumber': '购物车号:',
  'orderDetail.orderNumber': '订单号:',
  'orderDetail.serviceType': '服务类型:',
  'orderDetail.orderSource': '订单来源:',
  'orderDetail.tables': '桌号:',
  'orderDetail.employee': '服务员:',
  'orderDetail.driver_name': '司机:',
  'orderDetail.userName': '顾客姓名:',
  'orderDetail.phone': '顾客手机号:',
  'orderDetail.delivery_address': '递送地址:',
  'orderDetail.delivery_note': '递送备注:',
  'orderDetail.sub_total': '小计',
  'orderDetail.order_discount': '订单折扣',
  'orderDetail.dish_discount': '菜品折扣',
  'orderDetail.tax': '税',
  'orderDetail.estimatedTax': '预估税',
  'orderDetail.tips': '小费',
  'orderDetail.staff_tips': '服务小费',
  'orderDetail.driver_tips': '递送小费',
  'orderDetail.bill_total': '账单总计',
  'orderDetail.total': '订单合计',
  'orderDetail.compensate': '补偿',
  'orderDetail.taxable_fees_collected': '征税费用:',
  'orderDetail.non_taxable_fees_collected': '免税费用:',
  'orderDetail.customerInfo': '顾客信息',
  'orderDetail.rewardFlag': ' *兑换商品* ',
  'orderDetail.free': '免费',
  'orderDetail.taxExempt': '免税',
  'orderDetail.discountExempt': '免于整单折扣',

  'orderDetail.prepaid': '预付款',
  'orderDetail.charge_at_pickup': '取餐时支付',

  'orderDetail.action.viewTransactions': '查看交易详情',

  'orderDetail.refund.summary': '退款记录: {count} 项',
  'orderDetail.refund.created_at': '退款时间',
  'orderDetail.refund.cardLast4digit': '卡号后4位',
  'orderDetail.refund.staff': '员工',
  'orderDetail.refund.amount': '退款金额',
  'orderDetail.refund.summaryTotal': '退款总额: {amount}',
  'orderDetail.fee.summary': '费用明细: {count} 项',
  'orderDetail.refund.refundType': '退款类型',
  'orderDetail.refund.refundType.bill': '账单',
  'orderDetail.refund.refundType.tips': '小费',
  'orderDetail.refund.refundType.full': '全额',
  'orderDetail.refund.refundType.composite': '账单&小费',
  'orderDetail.refund.paymentType': '支付方式',

  'orderDetail.refund.refundType.payment_fee': '刷卡加收',
  'orderDetail.refund.refundType.bill&tips': '账单&小费',
  'orderDetail.refund.refundType.bill&payment_fee': '账单&刷卡加收',
  'orderDetail.refund.refundType.tips&payment_fee': '小费&刷卡加收',
  'orderDetail.refund.refundType.bill&tips&payment_fee': '账单&小费&刷卡加收',

  'orderDetail.section.orderDetails': '订单详细',
  'orderDetail.section.paymentDetails': '支付详细',
  'orderDetail.section.cashbackDetails': '返现详细',

  'orderDetail.cashbackIssued': '获取返现',

  'orderDetail.text.receipt.title': '发送短信收据',
  'orderDetail.email.receipt.title': '发送邮件收据',
  'orderDetail.text.receipt.placeholder': '输入手机号码',
  'orderDetail.email.receipt.placeholder': '输入邮件地址',
  'orderDetail.receipt.send.success': '发送收据成功',
  'orderDetail.receipt.send.failed': '发送收据失败',

  'orderDetail.checkbill.lineItems.summary': '分单明细: {count} 项',
  'orderDetail.checkbill.total': '分单合计',

  'orderDetail.transaction.title': '交易详情',

  'orderDetail.payment.summary': '支付明细',
  'orderDetail.payment.checkNumber': '分单#',
  'orderDetail.payment.paymentType': '支付方式',
  'orderDetail.payment.amount': '金额',
  'orderDetail.transaction.summary': '交易明细',

  'orderDetail.payment.tips': '小费',
  'orderDetail.payment.fees': '费用',
  'orderDetail.payment.paymentTotal': '支付合计',

  'orderDetail.operateLoggings': '操作日志',
  'orderDetail.operateLoggings.operator_name': '操作人',
  'orderDetail.operateLoggings.approver_name': '授权人',
  'orderDetail.operateLoggings.device_serial_number': '设备',
  'orderDetail.operateLoggings.operation_mode': '环境',
};
